import(/* webpackMode: "eager" */ "/Users/connorspackman/Developer/Cylerian/website/app/resources/page.js");
